import type { PermissionsMap } from "@/lib/api";

/**
 * Determines the landing route for the authenticated user based on their permissions.
 * Routes are checked in priority order — the first match wins.
 *
 * To add a new landing route for a new role/feature:
 * 1. Add an entry to LANDING_ROUTES with the feature key and target path.
 * 2. Ensure the feature exists in the backend's role_permissions table.
 */
const LANDING_ROUTES: Array<{ feature: string; path: string }> = [
  { feature: "dashboard-negocio", path: "/dashboard-negocio" },
  { feature: "dashboard-direccion", path: "/dashboard-direccion" },
  { feature: "facturacion", path: "/facturacion" },
];

const FALLBACK_ROUTE = "/pedidos";

export function getLandingRoute(permissions: PermissionsMap | undefined): string {
  if (!permissions) return FALLBACK_ROUTE;

  for (const { feature, path } of LANDING_ROUTES) {
    if (permissions[feature]?.canView) return path;
  }

  return FALLBACK_ROUTE;
}
